module.exports = __webpack_public_path__ + "img/notice.3cd6a138.png";